import { connect } from 'react-redux';
import { CartSidebar } from './CartSidebar';
import { mapStateToProps } from './CartSidebar.state';

export default connect(mapStateToProps)(CartSidebar);
